export class ListTextStyle {
  size = 'uk-h5';
  font = 'tb-font-primary';

  static normalize(textStyle: Partial<ListTextStyle>): ListTextStyle {
    const pureTextStyle = new ListTextStyle();

    pureTextStyle.size = textStyle.size ?? pureTextStyle.size;
    pureTextStyle.font = textStyle.font ?? pureTextStyle.font;

    return pureTextStyle;
  }
}
